import { api } from '@/core/helpers/axiosHelper';
import { AvailabilityTodo } from './availability-todo.interface';

export default {
   async post(body: AvailabilityTodo) {
      return await api.post('/availability-todo', body).then((response) => response?.data);
   },
};
